import type { TranslationKey } from "@shared/i18n/translationKey";

// Constantes de dominio del módulo vacancy.

// El backend (Manatal) envía la prioridad como "1 (Alta)" / "2 (Media)" /
// "3 (Baja)"; se mapea a la clave i18n correspondiente.
export const PRIORITY_LABEL_KEYS = {
  "1 (Alta)": "high",
  "2 (Media)": "half",
  "3 (Baja)": "low",
} satisfies Record<string, TranslationKey>;

// HTTP 503: el proveedor de vacantes (Manatal) no está disponible.
export const SERVICE_UNAVAILABLE_STATUS = 503;

// Tamaño de página del listado (paginación client-side).
export const VACANCIES_PER_PAGE = 5;
